import React, { createContext, ReactNode, useContext, useState } from "react";

interface ContextValue {
  setOpenMenu: React.Dispatch<React.SetStateAction<boolean>>;
  openMenu: boolean;
  changeMenu: () => void;
  message: any[];
  setMessage: React.Dispatch<React.SetStateAction<any[]>>;
  successMessage: any[];
  setSuccessMessage: React.Dispatch<React.SetStateAction<any[]>>;
}

const ContextOpen = createContext<ContextValue>({
  setOpenMenu: () => {},
  openMenu: true,
  changeMenu: () => {},
  message: [],
  setMessage: () => {},
  successMessage: [],
  setSuccessMessage: () => {},
});

const ContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [openMenu, setOpenMenu] = useState(true);
  const [message, setMessage] = useState<any[]>([]);
  const [successMessage, setSuccessMessage] = useState<any[]>([]);

  const changeMenu = () => {
    setOpenMenu(!openMenu);
  };

  return (
    <ContextOpen.Provider
      value={{
        setOpenMenu,
        openMenu,
        changeMenu,
        message,
        setMessage,
        successMessage,
        setSuccessMessage,
      }}
    >
      {children}
    </ContextOpen.Provider>
  );
};

export default ContextProvider;

export const useContextHook = () => {
  return useContext(ContextOpen);
};
